import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { usePregnancyStore } from '@/store/pregnancyStore';

/**
 * Hook for real-time synchronization of milestone changes
 * Listens to Supabase Realtime for changes to user_baby_milestones
 * and invalidates the query cache when changes occur
 */
export function useMilestoneSync() {
  const queryClient = useQueryClient();
  const { lastCompletedPregnancy } = usePregnancyStore();

  const pregnancyId = lastCompletedPregnancy?.id;

  useEffect(() => {
    if (!pregnancyId) return;

    const channel = supabase
      .channel(`baby-milestones-${pregnancyId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'user_baby_milestones',
          filter: `pregnancy_id=eq.${pregnancyId}`,
        },
        () => {
          // Invalidate queries to refresh data
          queryClient.invalidateQueries({ queryKey: ['baby-milestones'] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [pregnancyId, queryClient]);
}
